module.exports = __webpack_public_path__ + "db9b21a1c41f3dcd9731e1e7acfdbb57.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/en/google_store.png
// module id = 869
// module chunks = 0